import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from 'src/app/config';

@Injectable({
  providedIn: 'root'
})
export class JsonHandlingService {

  scaiServiceUrl = Config.assetConfigData['scaiServiceUrl'];
  private url = `${this.scaiServiceUrl}doc-processing-config`; 

  constructor(private http: HttpClient) { }


  getJsonDataReadOnly(type?: string, assetType?: string, language?: string, country?: string): Observable<any> {
    let url = `${this.url}?flattenConfig=false`;

    if (type) {
      url += `&run_type=${encodeURIComponent(type)}`;
    }
    if (assetType) {
      url += `&asset_type=${encodeURIComponent(assetType)}`;
    }
    if (language) {
      url += `&language=${encodeURIComponent(language)}`;
    }
    if (country) {
      url += `&country=${encodeURIComponent(country)}`;
    }

    console.log('Fetching JSON data from API:', url);

    return this.http.get(url).pipe(
      tap(data => console.log('API Response:', data))
    );
  }

  getJsonData(envId: number, type?: string, assetType?: string, language?: string, country?: string): Observable<any> {
    let url = `${this.url}?env_id=${envId}&flattenConfig=false&resolveConfig=false`;
    console.log('Fetching JSON data from API...');
    if (type) {
      url += `&run_type=${encodeURIComponent(type)}`;
    }

    if (assetType) {
      url += `&asset_type=${encodeURIComponent(assetType)}`;
    }

    if (language) {
      url += `&lang=${encodeURIComponent(language)}`;
    }
    
    if (country) {
      url += `&country=${encodeURIComponent(country)}`;
    }

    return this.http.get(url).pipe(
      tap(data => console.log('API Response:', data))
    );
  }

  saveJsonData(envId: number, newJson: any, type?: string, assetType?: string, language?: string, country?: string): Observable<any> {
    let url = `${this.url}?env_id=${envId}`;

    if (type) {
      url += `&run_type=${encodeURIComponent(type)}`;
    }

    if (assetType) {
      url += `&asset_type=${encodeURIComponent(assetType)}`;
    }

    if (language) {
      url += `&lang=${encodeURIComponent(language)}`;
    }
    
    if (country) {
      url += `&country=${encodeURIComponent(country)}`;
    }

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(url, newJson, { headers });
  }
}

